export enum GoogleDrivePickerAction {
  Picked = 'picked',
  Cancel = 'cancel',
}
